var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('HeadSection'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_vm._v(" hei"+_vm._s(_vm.isLoggedIn)+" "),_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }